import { createSelector } from "reselect";

// Valores por defecto constantes para evitar crear nuevas referencias y loops infinitos
const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];

// Selector Base
const selectZeroAutosState = (state) => state.dataZeroAutos || EMPTY_OBJECT;

// Selectores del Estado
export const selectAutos = createSelector(
  selectZeroAutosState,
  (state) => state.autos || EMPTY_ARRAY
);

export const selectAutoSeleccionado = createSelector(
  selectZeroAutosState,
  (state) => state.autoSeleccionado || null
);

export const selectIsLoading = createSelector(
  selectZeroAutosState,
  (state) => state.isLoading || false
);

export const selectError = createSelector(
  selectZeroAutosState,
  (state) => state.error || null
);
